module.exports = __webpack_public_path__ + "static/media/scr_phoneFrame_Ios.2c515422.png";